export const environment = {
    production: false,
    baseUrl: 'https://api.sandbox.7thaven.com/v1.1/',
    assetsUrl: "https://kyc.sandbox.7thaven.com/assets/",
    localKey: 'IYOTX3fNxSyOMcrp'
};
